/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthApiService } from '@revenuewell/logic-http';
import { OidcService } from '@revenuewell/logic-oidc';
import { NavigationService } from '@revenuewell/logic-navigation';

export default class SmsService extends AuthApiService {
  private config: any

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService())
    this.config = config
  }

  sendSms = async (fromLocationId: number, toPhone: string, text: string): Promise<void> => {
    const url = `${await this.config.textSender.apiUrl}/messages`
    const data = {
      fromLocationId: fromLocationId,
      to: toPhone,
      body: text
    };

    await this.authFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
  }
}
